import { KV } from '../common/Constant';
import qs from 'querystringify';
import { systemProbe, urljoin } from '../utils/utils';
import { generateSign, getSignType } from '../shared/aut';
import log from 'loglevel';

/**
 * 简单封装
 * @export
 * @class Http
 */
export default class Http {
  constructor(store) {
    this.store = store;
    this.e = {
      error: this._onError.bind(this),
      timeout: this._onTimeout.bind(this),
      onload: this._onLoad.bind(this),
      onLoadend: this._onLoadend.bind(this)
    };

    this.xhr = new XMLHttpRequest();
    // IE, 不支持赋值
    this.browserType = systemProbe().browser;
    if (this.browserType !== 'ie') {
      this.xhr.responseType = 'json';
      this.xhr.timeout = 10000;
    }
    this.xhr.onerror = this.e.error;
    this.xhr.ontimeout = this.e.timeout;
    this.xhr.onload = this.e.onload;
    this.xhr.onloadend = this.e.onLoadend;

    this.onError = null;
    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onError(e) {
    this.onError && this.onError(e.target.response);
    this.onError = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoad(e) {
    if (!e.target) {
      this._onError(e);
      return;
    }

    if (!e.target.response) {
      this._onError(e);
      return;
    }

    let response = e.target.response;
    // IE, 由于未赋值responseType为JSON，故手动解析
    if (this.browserType === 'ie' && response && typeof response === 'string') {
      try {
        response = JSON.parse(response);
      } catch (error) {
        response = e.target.response;
      }
    }
    let { code, data } = response;
    if (+code !== 200) {
      this._onError(e);
      return;
    }

    this.onLoad && this.onLoad(data);
    this.onLoad = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoadend(e) {
    this.onLoadend && this.onLoadend(e.target);
    this.onLoadend = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onTimeout(e) {
    this.onTimeout && this.onTimeout(e.target);
    this.onTimeout = null;
  }

  /**
   * 发送请求
   *
   * @param {*} apiURL API的URL
   * @param {*} data FormData
   * @param {string} method [method='POST']
   * @memberof Http
   */
  fire(apiURL, data = {}, method = 'POST') {
    if (!this.xhr) return;

    let url = apiURL.slice(0, 4).toLocaleLowerCase() === 'http' ? apiURL : urljoin(process.env.API_SERVER, apiURL);
    const reqData = {
      [KV.CLIENT]: this.store.getKV(KV.CLIENT),
      [KV.APP_ID]: this.store.getKV(KV.APP_ID),
      [KV.THIRD_PARTY_USER_ID]: this.store.getKV(KV.THIRD_PARTY_USER_ID),
      [KV.ACCESS_TOKEN]: this.store.getKV(KV.ACCESS_TOKEN),
      [KV.PACKAGE_CHECK]: this.store.getKV(KV.PACKAGE_CHECK),
      [KV.CHANNEL_ID]: this.store.getKV(KV.CHANNEL_ID)
    };
    let roomId = this.store.getKV(KV.ROOM_ID);
    if (roomId !== '') {
      reqData[KV.ROOM_ID] = roomId;
    }

    Object.keys(data).forEach(key => {
      reqData[key] = data[key];
    });

    this._appendSign(url, reqData); // 增加签名处理

    if (method === 'POST') {
      this.xhr.open(method, url);
      this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      this.xhr.send(qs.stringify(reqData));
    } else if (method === 'GET') {
      url += qs.stringify(reqData, true);
      this.xhr.open(method, url);
      this.xhr.send();
    }
  }

  /**
   * HTTP模块销毁
   *
   * @memberof Http
   */
  destroy() {
    if (!this.xhr) {
      return;
    }

    this.xhr.onerror = null;
    this.xhr.onload = null;
    this.xhr.onloadend = null;
    this.xhr.ontimeout = null;
    this.xhr = null;

    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
    this.onError = null;
  }

  _appendSign(url, data) {
    /* prettier-ignore */
    const matches = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(url);
    const pathname = matches[5] || '';
    const apiEndName = pathname.substring(pathname.lastIndexOf('/') + 1);
    log.info('apiEndName:', apiEndName);
    if (apiEndName.startsWith('s-')) {
      // s-开头的api, 增加签名
      data['signed_at'] = Date.now();
      data['sign_type'] = getSignType();
      const sign = generateSign(data);
      if (sign) {
        data['sign'] = sign;
        log.info('sign:', sign);
      }
    }
  }
}
